import { useQuery } from "@tanstack/react-query";
import type { IOverviewJointBillService } from "@services/overview/types";
import { getNonProfitProviders } from "./services";

export const useNonProfitProvidersQuery = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
  enabled = true,
) =>
  useQuery({
    queryKey: ["nonProfitProviders", jointBillServiceId],
    queryFn: () => getNonProfitProviders(jointBillServiceId),
    enabled,
  });
